import React from "react";

const Loader = () => (
  <div className="d-flex justify-content-center" >
    <div className="spinner-border" role="status" style={{marginTop: '20%'}}></div>
  </div>
);

export default Loader;
